export default "__VITE_PUBLIC_ASSET__098593b9__"